/**
 * @file
 * TOC script.
 */
let tocWrapper = document.querySelector('.toc-js');
let tocTitle = document.querySelector('.toc-title');
let tocButtonToggle = document.querySelector('.toc__toggle');

function collapseToc(e) {
  tocWrapper.classList.toggle('is-expanded');
  let expanded = tocWrapper.getAttribute('aria-expanded') === 'true' || false;
  tocWrapper.setAttribute('aria-expanded', !expanded);
  let expandedButton = tocButtonToggle.getAttribute('aria-expanded') === 'true' || false;
  tocButtonToggle.setAttribute('aria-expanded', !expandedButton);
}

tocTitle.addEventListener('click', function () {
  if (tocWrapper) {
    collapseToc();
  }
});

// Remove-reset the 'is-expanded' class when the TOC stops being sticked.
const config = { attributes: true};
// Callback function to execute when mutations are observed.
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    // If the mutation is the one we care for.
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      // If the element exist.
      if (typeof tocWrapper !== 'undefined' && tocWrapper !== null) {
        // If the 'is-sticked' is not there anymore but the 'is-expanded' is.
        if (!tocWrapper.classList.contains('is-sticked') && tocWrapper.classList.contains('is-expanded')) {
          collapseToc();
        }
      }
    }
  }
};
//  Create an observer instance linked to the callback function.
const observer = new MutationObserver(callback);
// Start observing the target node for configured mutations.
observer.observe(tocWrapper, config);

// Collapse the TOC after clicking on another chapter so it does not takes
// vertical space and the chapter can be read. It needs to happen after the TOC
// is loaded because toc.js creates the links after the HTML is rendered.
document.addEventListener("DOMContentLoaded", function() {
  let tocLinks = document.querySelectorAll('.toc-h2:not(.toc-active) a');
  tocLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      tocWrapper.classList.remove('is-expanded');
      tocWrapper.setAttribute('aria-expanded', false);
      tocButtonToggle.classList.remove('is-expanded');
      tocButtonToggle.setAttribute('aria-expanded', false);
    });
  });
});

